/**
 * @file Inline Youtube.
 */

/* global YT */

import { gsap } from 'gsap';
import vSetupYoutubeApi from '../../js/utilities/youtube-api';

/**
 * Inline Youtube component.
 */
const vInlineYoutube = () => {
	const inlineYoutube = document.querySelectorAll('.v-inline-youtube');

	if (!inlineYoutube.length) {
		return;
	}

	[...inlineYoutube].forEach((inline) => {
		const trigger = inline.querySelector('.v-inline-youtube__trigger');
		const img = inline.querySelector('.v-inline-youtube__img');
		const iframeWrap = inline.querySelector('.v-inline-youtube__iframe-wrap');
		const { id } = iframeWrap.dataset;
		let videoLoaded = false;
		let player;

		/**
		 * Load video.
		 */
		const loadVideo = () => {
			if (videoLoaded) return;

			videoLoaded = true;
			player = new YT.Player(iframeWrap, {
				videoId: id,
				playerVars: {
					playsinline: 1,
				},
				events: {
					onReady: (event) => {
						gsap.to([img, trigger], {
							opacity: 0,
							duration: 0.2,
							onComplete: () => {
								gsap.set([img, trigger], { display: 'none' });
							},
						});
						event.target.playVideo();
					},
				},
			});
		};

		trigger.addEventListener('click', () => {
			vSetupYoutubeApi();

			trigger.classList.add('v-inline-youtube__trigger--loading');

			if (videoLoaded) {
				player.playVideo();
			} else if (
				Object.prototype.hasOwnProperty.call(window, 'YT') &&
				window.YT.loaded
			) {
				loadVideo();
			} else {
				window.vYtCallbacks.push(loadVideo);
			}
		});
	});
};

export default vInlineYoutube;
